import { Component, OnInit, ChangeDetectionStrategy,
    Input, Output, EventEmitter, OnChanges, SimpleChanges, ElementRef, ContentChild, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable, fromEvent, Subscription } from 'rxjs';
import { tap, withLatestFrom } from 'rxjs/operators';

@Component({
    selector: 'shared-places-suggestion',
    templateUrl: './places-suggestion.shared.component.html',
    styleUrls: ['./places-suggestion.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlacesSuggestionComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    private _isLocked: boolean = false;
    private _isOpen: boolean = false;
    private _searchTimeout: number;
    private _searchTickTimeout: number = 500;

    @ContentChild('input', { static: false }) public inputElement: ElementRef<HTMLInputElement>;
    @Input() public searchTerm!: string;
    @Input() public refElem!: HTMLElement;
    @Input() public enabled: boolean = false;
    @Output() public onSelected: EventEmitter<APICommon.IGooglePlaceDetails> = new EventEmitter();

    public options$!: Observable<APICommon.IGooglePlaceDetails[]>;
    public inputEvents$!: Subscription;

    constructor(
        public controllers: Controllers,
        public changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        this.options$ = this.controllers.google.getAutocompleteResults$();
    }

    ngAfterViewInit(): void {
        const input = this.inputElement?.nativeElement;
        if(input) {
            this.inputEvents$ = fromEvent<KeyboardEvent>(input, 'keydown')
                .pipe(
                    withLatestFrom(
                        this.options$,
                    )
                )
                .subscribe(([event, options]) => {
                    if((event).keyCode === 13) {
                        if(options && options.length) {
                            event.preventDefault();
                            this.handleOnSelected(options[0]);
                            this.handleOnToggle(false);
                        }
                    }
                });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.enabled && this._isLocked === false && changes?.searchTerm?.currentValue !== changes?.searchTerm?.previousValue) {
            this._triggerSearch(changes.searchTerm.currentValue);
        }
    }

    ngOnDestroy(): void {
        if (this.inputEvents$ && !this.inputEvents$.closed) {
            this.inputEvents$.unsubscribe();
        }
    }

    public handleOnToggle($event: boolean): void {
        if (!$event && $event !== this._isOpen) {
            this._isOpen = $event;
        }
        this.changeDetectorRef.detectChanges();
    }

    public handleOnSelected($event: APICommon.IGooglePlaceDetails): void {
        this._tempLock();
        this.onSelected.emit($event);
    }

    public get open(): boolean {
        return this._isOpen;
    }

    private _tempLock(): void {
        this._isLocked = true;
        setTimeout(() => {
            this._isLocked = false;
        }, this._searchTickTimeout + 100);
    }

    private _killLock(): void {
        if (this._searchTimeout) {
            clearTimeout(this._searchTimeout);
            this._searchTimeout = null;
        }
    }

    private _triggerSearch(term: string): void {
        if (term) {
            this._killLock();

            this._searchTimeout = window.setTimeout(() => {
                this.controllers.google.getAutocompleteSuggestion(term.trim() || null);
                this._isOpen = true;
            }, this._searchTickTimeout);

        } else {
            this._killLock();
            this._isOpen = false;
        }
    }

}
